import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import DropDownCellAllProdutoGridsSemContas from './myDropDownCellAllProdutoGridsSemContas';

var optionsProdutos = [];

var optionsProdutosFilter = [];

var DropDownCellTipoVasilha = null;

var filterArray = [];

var ProdutoToSearch = null;

var thisCellAllProdutos = null

class DropDownCellAllProdutoGridsEngarrafado extends Component {
  state = {
    optionsProdutos: [],
    optionsProdutosFilter: [],
    selectedValue: null, 
  };

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    DropDownCellAllProdutoGridsSemContas.BlockFieldSemConta(e.target.value.value)
  }
// chama a função quando se seleciona uma entidade
  static GetAllProdutos(tipoProduto , idEntidade){
    
      var ProdutoString = {};

      optionsProdutosFilter = [];

      (async () => {
        if($('#instal_vinica_auto').val() != '' & $('#instal_vinica_auto').val() != null){
          const data = {IDInstalacaoVinica:$('#instal_vinica_auto').val().split('!')[0] , Tipos: tipoProduto , idEntidade: idEntidade}
          const ProdutoList = await services.apiCall.requestApi(
              "/Fiscalizacao/GetAllProdutosPorTipo",
              data,
              "get"
          );

          if(ProdutoList){
            ProdutoList.map((Produto) => (
              ProdutoString = {text: "" + Produto.produto + " - " + Produto.tipoConta + " - " + (Produto.numeroRegisto != null ? Produto.numeroRegisto : 0) + " - " + Produto.cor + " - " + Produto.anoProduto + " - " + Produto.estado + " - " + Produto.saldo,
              value: Produto.idContaCorrente},

              ProdutoString.text += Produto.mencoes != "" || Produto.mencaoObrigatoria != "" ? (Produto.mencoes != "" ? " - " + Produto.mencoes : " - Sem menção") + (Produto.mencaoObrigatoria != "" ? " - " + Produto.mencaoObrigatoria : " - Sem menção qualitativa") : " - Sem menções",

              optionsProdutosFilter.push(ProdutoString)
            ));

            optionsProdutosFilter.push(
              { text: "Outros", value: "Outros" },
              { text: "Produtos sem conta corrente", value: "ProdutosSemConta" }
            );
          }

        }
      })();
      
  }

// chama a função quando carrega a grid para por os produtos da entidade do auto por default
  GetAllProdutos2(tipoProduto , idEntidade){
    
    var ProdutoString = {};


    optionsProdutosFilter = [];

    (async () => {
      if($('#instal_vinica_auto').val() != '' & $('#instal_vinica_auto').val() != null){
        const data = {IDInstalacaoVinica:$('#instal_vinica_auto').val().split('!')[0] , Tipos: tipoProduto , idEntidade: idEntidade}
        const ProdutoList = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAllProdutosPorTipo",
            data,
            "get"
        );

        if(ProdutoList){
          ProdutoList.map((Produto) => (
            ProdutoString = {text: "" + Produto.produto + " - " + Produto.tipoConta + " - " + (Produto.numeroRegisto != null ? Produto.numeroRegisto : 0) + " - " + Produto.cor + " - " + Produto.anoProduto + " - " + Produto.estado + " - " + Produto.saldo,
            value: Produto.idContaCorrente},

            ProdutoString.text += Produto.mencoes != "" || Produto.mencaoObrigatoria != "" ? (Produto.mencoes != "" ? " - " + Produto.mencoes : " - Sem menção") + (Produto.mencaoObrigatoria != "" ? " - " + Produto.mencaoObrigatoria : " - Sem menção qualitativa") : " - Sem menções",

            optionsProdutosFilter.push(ProdutoString)
          ));

          optionsProdutosFilter.push(
              { text: "Outros", value: "Outros" },
              { text: "Produtos sem conta corrente", value: "ProdutosSemConta" }
            );

            this.setState({ 
              optionsProdutosFilter: optionsProdutos,
            });
        }

      }
    })();
    
}

  componentDidMount = () => {

    (async () => {
      // chama a função quando carrega a grid para por os produtos da entidade do auto por default
      this.GetAllProdutos2(this.props.tipoProduto , parseInt($("#instal_vinica_auto :selected").val().split("!")[1]));

      this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field
      });

      if(this.props.dataItem.idEntidadesInst != null){
        this.GetAllProdutos2(this.props.tipoProduto , this.props.dataItem.idEntidadesInst);
      }

    })();
  }


  filterData = (filter) => {

    var FilterOptions = [];

    var indexCheck = [];

    filterArray = [];

    filterArray = filter.value.split(" ")

    $.map( optionsProdutos, function( val, i ) {

      ProdutoToSearch = val;

      indexCheck = [];

      $.map( filterArray, function( val, i ) {

        if(ProdutoToSearch.text.toUpperCase().indexOf(val.toUpperCase()) > -1){
          indexCheck.push("true");
        }else{
          indexCheck.push("false")
        }

      })
  
      if(indexCheck.indexOf("false") == -1){
        FilterOptions.push(ProdutoToSearch);
      }

    })

    optionsProdutosFilter = FilterOptions;

  };


  filterChange = (event) => {

    this.filterData(event.filter);

    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field
    });

  };

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    optionsProdutosFilter = optionsProdutosFilter.length < optionsProdutos.length ? optionsProdutosFilter : optionsProdutos;

    if(dataItem.idContaCorrenteEng != undefined && dataItem.idContaCorrenteEng != null && optionsProdutosFilter.length> 0){
      var dataEnter = optionsProdutosFilter.find(c => c.value === (dataItem.idContaCorrenteEng))
    }
    
    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
                filterable={true}
                onFilterChange={this.filterChange}
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={dataEnter ? dataEnter : optionsProdutosFilter.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                data={optionsProdutosFilter}
                textField="text"
                id='id-DropDownCellAllProdutos'
            />
            : dataValue != null  ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined}
        </td>
    );
  }
}

export default DropDownCellAllProdutoGridsEngarrafado;